import { render } from "./TournamentForm.vue?vue&type=template&id=3f02050d&scoped=true"
import script from "./TournamentForm.vue?vue&type=script&lang=js"
export * from "./TournamentForm.vue?vue&type=script&lang=js"

import "./TournamentForm.vue?vue&type=style&index=0&id=3f02050d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f02050d"]])

export default __exports__